import React from 'react';
// import {Link} from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';


function Header() {
    return (
        <header className="fixed w-full h-8 backdrop-blur-xl z-50 drop-shadow-lg bg-white/30">
            <div className="wrap flex items-center justify-between h-full">
                <h1 className="logo">
                    <HashLink smooth to="/#">
                        <svg width="140" height="49" viewBox="0 0 140 49" fill="#333333" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.2013 7.78866C10.0983 7.78866 -0.0370241 16.3202 0.000101672 27.9474C-0.0370241 39.499 10.0983 47.9928 22.2013 47.9551C34.4528 47.9928 44.5882 39.499 44.6253 27.9474C44.5882 16.3202 34.4528 7.78866 22.2013 7.78866ZM11.2121 27.9474C11.175 21.6808 16.1127 18.17 22.2013 18.2078C28.3642 18.17 33.0792 21.6808 33.1163 27.9474C33.0792 34.1762 28.3642 37.9512 22.2013 37.9135C16.1127 37.9512 11.175 34.1762 11.2121 27.9474Z" fill="#333333"/>
                        <path d="M75.606 17.8303V17.7548H92.3869V8.01516H47.5389V17.7548H63.6515V17.8303C63.6515 27.1169 59.1964 36.0259 44.7916 38.9705L50.212 48.2571C59.9018 45.8788 66.139 40.7825 69.6288 34.0252C73.0815 40.7825 79.3186 45.8788 89.0456 48.2571L94.466 38.9705C80.024 36.0259 75.5689 27.1169 75.606 17.8303Z" fill="#333333"/>
                        <path d="M140 8.07858H123.368V0H111.487V8.07858H94.3353V17.8937H140V8.07858ZM98.6419 34.8059C98.6419 43.1487 106.513 49 117.279 49C128.12 49 136.065 43.1487 136.139 34.8059C136.065 26.614 128.12 20.6495 117.279 20.6872C106.513 20.6495 98.6419 26.614 98.6419 34.8059ZM110.819 34.8059C110.819 31.8991 113.566 30.7666 117.279 30.7288C121.066 30.7666 123.776 31.8991 123.813 34.8059C123.776 37.8636 121.066 38.9962 117.279 39.0339C113.566 38.9962 110.819 37.8636 110.819 34.8059Z" fill="#333333"/>
                        </svg>
                    </HashLink>
                </h1>
                <nav>
                    <ul className="flex">
                        <li className="pl-4">
                            <HashLink smooth to="/#introduce" title="" className="hover:text-cyan-200">INTRODUCE</HashLink>
                        </li>
                        <li className="pl-4">
                            <HashLink smooth to="/#works" title="" className="hover:text-cyan-200">WORKS</HashLink>
                        </li>
                        <li className="pl-4">
                            <HashLink smooth to="/#contact" title="" className="hover:text-cyan-200">CONTACT</HashLink>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    );
}

export default Header;